
export class LossReason {
    constructor({
                    //attributes
                    id= null,
                    company_id= null,
                    deal_id= null,
                    user_id= null,
                    title= '',
                    observation= '',
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null
                } = {}) {

        //fill attributes
        this.id=id;
        this.company_id=company_id;
        this.deal_id=deal_id;
        this.user_id=user_id;
        this.title=title;
        this.observation=observation;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;


    }

}

export function createLossReason(data={}) {
    return Object.freeze(new LossReason(data));
}